var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-notification-box"},[_c('icon',{staticClass:"icon",attrs:{"name":_vm.symbol}}),_vm._v("\n    0\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }